import { reduceUrlParts } from "../index";
export const generateTeamUrl = ({ basePath, contextUrlPrefix, host, isApp = false, langPath, queryString, slug, }) => {
    if (isApp) {
        if (!host) {
            throw new Error(`❌ [@fede/utils > generateTeamUrl: option \`host\` is required when \`isApp\` is true`);
        }
        const appQueryString = new URLSearchParams({
            team_id: slug,
        }).toString();
        return host + reduceUrlParts([basePath || "news"], appQueryString);
    }
    const parts = [host, contextUrlPrefix || langPath, basePath, slug];
    return reduceUrlParts(parts, queryString);
};
